import styled from 'styled-components';

export const SupplierProgressCardMainWrap = styled.div(
  props => `
        .suppliersProgressCard{
    padding: 24px;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    margin-bottom: 20px;
    align-items: flex-start;
}

.suppliersProgressCard .verifiedPersuasion{
    //padding: 4px 8px;
    border-radius: 4px;
    margin-top: 8px;
    padding: 6px;
}

.suppliersProgressCard .verifiedPersuasion.inProcess{
    background-color: #FFEDD1;
    color: #A5572A;

}

.suppliersProgressCard .verifiedPersuasion.verified{
    background-color: #E6FFF9;
    color: #007E7D;
}

.suppliersProgressCard .verifiedPersuasion.inValid{
    background: #FFD3D4;

}
    `,
);
